module.exports = __webpack_public_path__ + "public/img/home_in2.fc2ecd7e.png";